import type {ReactNode} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faPlus, faSpinner} from '@fortawesome/free-solid-svg-icons';

interface ProblemDestinationToggleProps {
    title: string;
    description?: string;
    actionLabel: string;
    icon: ReactNode;
    selected: boolean;
    busy?: boolean;
    onClick: () => void;
    info?: ReactNode;
}

export const ProblemDestinationToggle = ({
    title,
    description,
    actionLabel,
    icon,
    selected,
    busy = false,
    onClick,
    info,
}: ProblemDestinationToggleProps) => (
    <div className="problem-destination-toggle" data-selected={selected}>
        <button
            type="button"
            className="problem-destination-toggle-button"
            aria-label={actionLabel}
            aria-pressed={selected}
            aria-busy={busy}
            disabled={busy}
            onClick={onClick}>
            <span className="problem-destination-icon" aria-hidden="true">
                {icon}
            </span>
            <span className="problem-destination-copy">
                <span className="problem-destination-title">{title}</span>
                {description && (
                    <span className="problem-destination-description" role="status">
                        {description}
                    </span>
                )}
            </span>
            <FontAwesomeIcon
                className="problem-destination-state"
                icon={busy ? faSpinner : selected ? faCheck : faPlus}
                spin={busy}
                aria-hidden="true"
            />
        </button>
        {info}
    </div>
);
